/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../core/navigation';
import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    ON_VISIBILITY_HIDE_INFOCARD,
    ON_VISIBILITY_SHOW_INFOCARD,
    SET_INFOCARD_HIGHLIGHT,
} from './infocard.types';

export const onVisibilityShowInfoCardAction = (
    callerScreenTaskController: string,
): TivoPayloadAction<{ callerScreenTaskController: string }> => ({
    type: ON_VISIBILITY_SHOW_INFOCARD,
    payload: { callerScreenTaskController },
});

export const onVisibilityHideInfoCardAction = (): TivoPayloadAction<{
    callerScreenTaskController: string;
}> => ({
    type: ON_VISIBILITY_HIDE_INFOCARD,
    payload: {
        callerScreenTaskController: ScreenTaskControllerTypes.NO_TASK,
    },
});

export const setInfoCardHighlightAction = (
    highlight: number,
): TivoPayloadAction<{ highlight: number }> => ({
    type: SET_INFOCARD_HIGHLIGHT,
    payload: { highlight },
});
